import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { tinycolor as r } from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
import { getBackgroundColor as i } from "./spec-util.js";
import { stylable as a } from "../decorators/stylable.js";
import "../decorators.js";
//#region src/specs/nodes/button-spec.ts
var o = (e) => {
	let t = e.querySelector("a"), n = t?.style?.backgroundColor;
	return n === "transparent" && (n = t?.style?.borderColor), n ? i(n) : "";
}, s = (e) => r(e).isValid() ? r(e).getLuminance() > .179 ? "color: #000000;" : "color: #ffffff;" : "", c = (e) => e.attrs.buttonStyle === "outline" ? `border-color: ${e.attrs?.backgroundColor}; background-color: transparent; border-style: solid;` : `border-color: transparent; background-color: ${e.attrs?.backgroundColor}; border-style: solid;`;
function l(e) {
	return e.querySelector("a")?.style?.backgroundColor === "transparent" ? "outline" : "solid";
}
var u = a(n({
	inline: !1,
	attrs: t({
		type: { default: "button" },
		linkUrl: { default: "" },
		text: { default: "" },
		buttonStyle: { default: "solid" }
	}),
	group: "block",
	parseDOM: [{
		tag: `div.${e.button}`,
		getAttrs(e) {
			return {
				linkUrl: e.getAttribute("data-link-url"),
				text: e.textContent,
				backgroundColor: o(e),
				buttonStyle: l(e)
			};
		}
	}, {
		tag: "div.intercom-interblocks-button",
		getAttrs(e) {
			return {
				linkUrl: e.querySelector("a")?.getAttribute("href"),
				text: e.textContent,
				backgroundColor: o(e),
				buttonStyle: l(e)
			};
		}
	}],
	toDOM(t) {
		let n = t.attrs, { text: r } = n, { fontColor: i } = n;
		r ??= "Enter button text";
		let a = i ? `color: ${i};` : s(n.backgroundColor), o = c(t);
		return [
			"div",
			{
				class: `${e.blockContainer} ${e.button}`,
				"data-link-url": n.linkUrl
			},
			[
				"a",
				{
					class: "intercom-h2b-button",
					style: `${o} ${a} `
				},
				r
			]
		];
	}
}));
//#endregion
export { u as buttonSpec, o as getButtonBackgroundColor };
